import { render, staticRenderFns } from "./defaultFooter.vue?vue&type=template&id=62274e54&scoped=true"
import script from "./defaultFooter.vue?vue&type=script&lang=js"
export * from "./defaultFooter.vue?vue&type=script&lang=js"
import style0 from "./defaultFooter.vue?vue&type=style&index=0&id=62274e54&prod&rel=stylesheet%2Fscss&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62274e54",
  null
  
)

export default component.exports